export default "__VITE_ASSET__CS391NHK__"